import { Component, OnInit } from '@angular/core';
import { SelectItem } from 'primeng';
import { RoutesService } from '../../services';
import { IPageRoles, IRouteRoles } from '../../interfaces/permission';
import { Observable } from 'rxjs';

@Component({
  selector: 'routes',
  templateUrl: './routes-roles.component.html',
  styleUrls: ['./routes-roles.component.css'],
})
export class RoutesRolesComponent implements OnInit {
  isBusy: boolean;
  routes: IGridItem[];
  roles: SelectItem[];
  permissions: SelectItem[];

  constructor(private routesService: RoutesService) {}

  ngOnInit(): void {
    this.isBusy = true;

    Promise.all([this.routesService.getPageRoles(), this.routesService.getRouteRoles()]).then(
      (result) => {
        let pagesRoles: IPageRoles[] = result[0];
        let routesRoles: IRouteRoles[] = result[1];

        this.routes = [
          ...this.convertFromPageRoles(pagesRoles),
          ...this.convertFromRouteRoles(routesRoles),
        ];

        this.fillRoles(pagesRoles, routesRoles);

        this.isBusy = false;
      },
    );
  }

  private convertFromPageRoles(roles: IPageRoles[]): IGridItem[] {
    return roles.map((p) => {
      return {
        path: p.path,
        title: p.title,
        roles: p.roles,
      };
    });
  }

  private convertFromRouteRoles(roles: IRouteRoles[]): IGridItem[] {
    return roles.map((p) => {
      return {
        path: `[${p.actionVerb}] ${p.actionPath}`,
        roles: p.roles,
      };
    });
  }

  private fillRoles(pagesRoles: IPageRoles[], routesRoles: IRouteRoles[]) {
    Observable.from(
      pagesRoles.map((item) => item.roles).concat(routesRoles.map((item) => item.roles)),
    )
      .flatMap((x) => x)
      .distinct()
      .toArray()
      .subscribe((arr) => {
        let items = arr.sort().map((item) => {
          return { label: item, value: item };
        });
        this.roles = [{ label: 'Any', value: null }, ...items];
      });
  }
}

interface IGridItem {
  path: string;
  title?: string;
  roles: string[];
}
